export const visit = (vm, at) => {
at({ "en": { "calling-orchestration-shared-library": { "error": { "withErrorBoundary": { "title": "An error occurred.", "message": "Please refresh the page." } } } } });
};